module.exports = __webpack_public_path__ + "static/media/yoga.dbd4f909.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/yoga.jpg
// module id = 469
// module chunks = 0